import { Outlet } from "react-router";
import Header from "../../../../../component/layout/header";
import useNav from "../../../../../script/tabingNavArray";

const BrandsLayout = () => {
  const navList = useNav();
  let { brandsBottomHeader, OperationsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={brandsBottomHeader} topTabs={OperationsTopHeader} />
      <Outlet />
    </div>
  );
};

export default BrandsLayout;
